import { render, staticRenderFns } from "./scrollBox.vue?vue&type=template&id=0e454f0e&scoped=true&"
import script from "./scrollBox.vue?vue&type=script&lang=js&"
export * from "./scrollBox.vue?vue&type=script&lang=js&"
import style0 from "./scrollBox.vue?vue&type=style&index=0&id=0e454f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e454f0e",
  null
  
)

export default component.exports